import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Input, Space, message } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { customerApi } from '@/services/api';

const CustomerList = () => {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadCustomers();
  }, [pagination.current, pagination.pageSize]);

  const loadCustomers = async () => {
    setLoading(true);
    try {
      const response = await customerApi.list({
        page: pagination.current,
        limit: pagination.pageSize,
        search
      });

      if (response.data.success) {
        setCustomers(response.data.data);
        setPagination({
          ...pagination,
          total: response.data.pagination.total
        });
      }
    } catch (error) {
      message.error('載入客戶列表失敗');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: '客戶編號',
      dataIndex: 'customer_code',
      key: 'customer_code'
    },
    {
      title: '公司名稱',
      dataIndex: 'company_name',
      key: 'company_name'
    },
    {
      title: '聯絡人',
      dataIndex: 'contact_name',
      key: 'contact_name'
    },
    {
      title: '電話',
      dataIndex: 'phone',
      key: 'phone'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: '價格層',
      dataIndex: 'price_tier',
      key: 'price_tier'
    }
  ];

  return (
    <div>
      <Card>
        <Space style={{ marginBottom: 16 }} wrap>
          <Input
            placeholder="搜尋客戶"
            prefix={<SearchOutlined />}
            style={{ width: 250 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={loadCustomers}
          />
          <Button onClick={loadCustomers}>查詢</Button>
          <Button type="primary" icon={<PlusOutlined />}>
            新增客戶
          </Button>
        </Space>

        <Table
          columns={columns}
          dataSource={customers}
          loading={loading}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 筆`,
            onChange: (page, pageSize) => {
              setPagination({ ...pagination, current: page, pageSize });
            }
          }}
        />
      </Card>
    </div>
  );
};

export default CustomerList;
